import Icon from '@susu/headless-commerce/components/Icon/Icon'
import classNames from 'classnames'
import { ClientNavCloseButton } from './ClientNavCloseButton'
import styles from './NavCloseButton.module.scss'

export type NavCloseButtonProps = {
  className?: string
}

export const NavCloseButton = ({ className }: NavCloseButtonProps) => {
  const closeButtonClass = classNames(styles['.nav__close-button'], className)

  return (
    <ClientNavCloseButton className={closeButtonClass}>
      <Icon icon="close" aria-hidden="true" />
      <span className="sr-only">Close</span>
    </ClientNavCloseButton>
  )
}
